import MobileDrawer from '@c/drawers/MobileDrawer';
import { CheckCircleIcon } from '@c/icons';
import BaseModal from '@c/modals/BaseModal';
import { isMobile } from '@util/index';

export const SORT_OPTIONS = [
  'Newest listings',
  'Most Favorited',
  'Alphabetically (A-Z)',
  'Highest Price',
  'Lowest Price',
];

export const SortModal = ({
  open,
  toggle,
  sortSelected,
  onSelectSort,
}: {
  open: boolean;
  toggle: () => void;
  sortSelected: string | null;
  onSelectSort: (text: string) => void;
}) => {
  const options = SORT_OPTIONS;

  const onOptionClick = (text: string) => onSelectSort(text);

  const _isMobile = isMobile();

  const Base = _isMobile ? MobileDrawer : BaseModal;

  return (
    <Base isOpen={open} show={open} dismiss={toggle} title="Sort">
      <div className="flex flex-col">
        {options.map((op) => (
          <button
            key={op}
            className={`flex justify-between px-8 py-6 text-body-md font-medium ${
              sortSelected === op ? 'bg-[#f1f1f1]' : ''
            }`}
            onClick={() => onOptionClick(op)}
          >
            {op}
            {sortSelected === op ? <CheckCircleIcon /> : null}
          </button>
        ))}
      </div>
    </Base>
  );
};
